import { useEffect } from "react";
import { CarIcon } from "./AuthIcons";

// Shared page shell for the auth flow (phone + OTP screens).
// Renders the brand mark, heading and a card containing the form,
// keeping both login screens visually identical. Page stays RTL;
// inner numeric/code elements opt into LTR themselves where needed.
function AuthLayout({ badgeIcon, title, children, footer }) {
  useEffect(() => {
    document.title = "ورود | تسمه";
    return () => {
      document.title = "تسمه";
    };
  }, []);

  return (
    <div className="auth-page" dir="rtl" lang="fa">
      <span className="auth-page__halo auth-page__halo--one" aria-hidden="true" />
      <span className="auth-page__halo auth-page__halo--two" aria-hidden="true" />
      <div className="auth-wrap">
        <header className="auth-brand">
          <span className="auth-brand-disc" aria-hidden="true">
            <CarIcon size={24} />
          </span>
          <span className="auth-brand-copy">
            <strong className="auth-brand-name">تسمه</strong>
            <small className="auth-brand-tag">تعمیر و سرویس ماشین هوبر</small>
          </span>
        </header>

        <main className="auth-card" role="main">
          <div className="auth-card-head">
            <div className="auth-card-icon" aria-hidden="true">
              {badgeIcon}
            </div>
            <div className="auth-card-heading">
              <h1 className="auth-title">{title}</h1>
            </div>
          </div>
          <div className="auth-body">{children}</div>
        </main>

        {footer && <p className="auth-footer">{footer}</p>}
      </div>
    </div>
  );
}

export default AuthLayout;
